import router from './app/router/router'
import store from './store'
// import { Auth } from '@/utils/auth'
// import lazyLoading from './store/modules/menu/lazyLoading'
import { whiteList } from '@/app/router/router'
import { Auth } from '@/core/utils/auth'



function getTokenFromParams (route) {
  const parsedParams = {}
  route.hash.split('&')
  .map(part => part.replace(/#/, ''))
  .forEach(param => {
    const parts = param.split('=')
    parsedParams[parts[0]] = parts[1]
  })
  return parsedParams['id_token']
}

router.beforeEach((to, from, next) => {
  if (!_.isEmpty(to.hash)) {
    let token = getTokenFromParams(to)
    let payload = Auth.login(token)
    if ( token && payload ) {
      store.dispatch('Login', {token, payload})
      next({ path: '/' })
      return
    }
  }
  // for now we dotn activate secure feature
  if (store.getters.isUserLogged) {
    if (to.path === '/login') {
      next({ path: '/' })
    } else {
      next()
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      // if the user ask a login-liek url, we let it though.
      // it's because we need to whitlist login token in param
      if (to.path.includes('/login/')) {
        next()
      } else {
        next({ path: '/login' })
      }
    }
  } 
})



// WEBPACK FOOTER //
// ./src/permission.js